var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeofgold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 576.522 576.522",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.941,289.311c-7.776,0.561-19.092,0.575-27.773-1.759c-1.456-0.392-1.392-0.9,0.11-1.035 c42.289-3.855,79.637-19.556,99.267-40.649c5.588-6.01,9.994-12.601,13.124-19.657c1.42-3.198,2.305-6.582,3.458-9.878 c1.239-3.54,1.472-5.389,1.261-6.3c-0.34-1.469-2.555,0.89-2.992,2.332c-0.572,1.894-1.147,3.782-1.935,5.606 c-1.649,3.813-3.791,7.442-6.159,10.973c-0.839,1.251-2.157,1.196-2.935-0.095c-3.32-5.514-6.846-10.952-8.097-16.337 c-0.343-1.469-0.677-1.493-0.747,0.012c-0.446,9.55,5.413,20.82,0.539,29.067c-5.013,8.473-17.277,14.737-28.44,19.676 c-22.49,9.954-52.029,12.965-77.62,20.062c-27.411,7.604-44.657,21.038-54.235,37.87c-0.746,1.311-1.416,1.182-1.612-0.314 c-0.132-0.998-0.284-2.004-0.468-3.018c-3.329-18.51-9.921-37.439-9.407-55.582c0.487-17.096,7.88-33.25,23.162-45.358 c3.613-2.849,7.613-5.465,11.899-7.889c2.638-1.5,11.562-5.771,13.023-6.136c37.231-9.21,68.682-29.474,83.756-52.833 c4.299-6.668,7.476-13.767,9.461-21.163c0.9-3.351,1.301-6.824,1.952-10.236c0.658-3.442,0.692-5.297,0.453-6.236 c-0.373-1.459-2.23,1.034-2.457,2.524c-0.294,1.949-0.588,3.893-1.083,5.802c-1.028,3.975-2.519,7.828-4.217,11.613 c-0.618,1.377-1.839,1.472-2.714,0.245c-3.577-5.015-7.32-9.93-9.052-15.08c-0.48-1.429-0.783-1.417-0.67,0.089 c0.7,9.529,7.236,19.966,3.831,28.764c-3.504,9.042-13.739,16.806-23.143,23.121c-18.948,12.721-44.991,19.453-67.039,29.731 c-42.105,19.636-53.247,53.553-47.503,89.927c0.235,1.49-0.542,1.983-1.84,1.212c-0.581-0.346-1.178-0.68-1.787-1.007 c-1.331-0.71-3.28-2.114-4.36-3.167c-5.092-4.963-11.117-9.648-18.188-13.99c-20.734-12.721-45.842-22.369-63.223-37.164 c-8.623-7.341-17.91-16.221-20.361-25.603c-2.384-9.125,5.297-18.755,7.078-28.14c0.281-1.481-0.016-1.533-0.655-0.165 c-2.308,4.917-6.582,9.379-10.71,13.954c-1.01,1.12-2.212,0.884-2.668-0.551c-1.258-3.957-2.298-7.953-2.867-12.017 c-0.272-1.952-0.346-3.917-0.417-5.888c-0.055-1.505-1.615-4.195-2.154-2.788c-0.346,0.909-0.521,2.751-0.26,6.249 c0.257,3.467,0.263,6.961,0.774,10.392c1.132,7.576,3.479,14.988,6.992,22.102c12.32,24.921,41.261,48.629,77.204,62.017 c1.413,0.526,1.35,1.086-0.159,1.129c-7.959,0.229-17.555-2.265-24.144-4.529c-1.426-0.49-1.814,0.04-0.759,1.117 c4.642,4.734,12.139,9.042,21.576,9.489c3.118,0.162,5.891-0.765,8.721-1.649c4.287-1.34,4.554,0.229,7.005,2.02 c3.983,2.895,7.662,5.949,10.927,9.189c13.804,13.768,19.312,30.658,17.853,47.697c-0.053,0.605-0.113,1.215-0.184,1.82 c-0.113,1.006-0.631,2.977-1.215,4.365c-1.524,3.615-3.492,7.084-5.609,10.506c-0.793,1.281-2.521,1.717-3.819,0.943 c-2.2-1.314-4.296-2.688-6.165-4.189c-1.176-0.945-1.304-0.836-0.374,0.348c1.671,2.127,3.357,4.254,5.073,6.375 c0.949,1.172,1.06,3.145,0.248,4.418c-4.718,7.43-9.002,14.984-9.669,23.666c-0.145,1.826-0.202,3.664-0.19,5.506 c0.01,1.508-0.608,1.707-1.532,0.514c-8.22-10.576-21.598-17.553-29.496-28.418c-1.649-2.266-3.026-4.691-4.202-7.229 c-0.633-1.367-0.909-2.879-0.694-3.338c0.214-0.459,0.192-0.541-0.074-0.199s-0.93-0.508-1.42-1.938 c-1.107-3.24-1.967-6.605-2.665-10.039c-0.737-3.613-2.142-7.424-0.536-11.812c1.362-3.727,4.394-7.518,6.463-11.252 c4.073-7.398,7.592-14.732,10.97-22.062c0.631-1.369,0.48-1.447-0.452-0.266c-4.942,6.252-12.684,11.334-18.045,17.375 c-1,1.129-1.891,0.893-2.121-0.598c-5.59-36.398-26.521-65.318-72.604-71.221c-24.128-3.087-50.986-1.579-72.904-7.935 c-10.875-3.155-22.99-7.439-29.076-14.988c-5.918-7.344-2.871-19.275-5.098-28.565c-0.352-1.466-0.643-1.39-0.667,0.116 c-0.085,5.431-2.154,11.251-4.036,17.121c-0.462,1.435-1.655,1.713-2.662,0.591c-2.77-3.091-5.358-6.31-7.549-9.78 c-1.052-1.667-1.921-3.43-2.797-5.199c-0.667-1.353-3.194-3.164-3.109-1.659c0.055,0.97,0.655,2.724,2.326,5.805 c1.659,3.054,3.097,6.239,4.973,9.159c4.14,6.444,9.324,12.24,15.45,17.283c21.466,17.666,57.589,27.405,95.858,24.859 c1.505-0.101,1.677,0.438,0.321,1.096c-7.164,3.476-16.938,5.144-23.875,5.78c-1.502,0.138-1.637,0.78-0.232,1.331 c6.175,2.411,14.783,3.265,23.571-0.205c2.91-1.132,5.055-3.115,7.277-5.083c3.36-2.98,4.247-1.659,7.215-1.035 c4.819,1.004,9.428,2.28,13.736,3.896c18.241,6.888,30.196,20.028,35.857,36.166c6.01,17.128,5.483,37.163,7.944,55.812 c0.814,6.182,2.344,11.852,4.443,17.166c0.554,1.402,0.129,3.318-0.991,4.33c-1.686,1.527-3.299,3.082-4.743,4.707 c-1,1.125-1.891,0.893-2.121-0.598c-5.59-36.398-26.521-65.318-72.602-71.221c-24.128-3.088-50.985-1.578-72.904-7.935 c-10.875-3.155-22.99-7.439-29.076-14.988c-5.918-7.344-2.87-19.275-5.098-28.565c-0.352-1.466-0.643-1.389-0.667,0.116 c-0.085,5.432-2.154,11.252-4.036,17.121c-0.462,1.435-1.655,1.713-2.662,0.59c-2.769-3.091-5.358-6.31-7.549-9.78 c-1.053-1.667-1.922-3.43-2.797-5.199c-0.667-1.353-3.195-3.164-3.109-1.659c0.055,0.97,0.655,2.724,2.325,5.805 c1.659,3.054,3.097,6.239,4.973,9.159c4.14,6.444,9.324,12.237,15.45,17.283c21.466,17.667,57.589,27.405,95.857,24.86 c1.505-0.102,11.304,1.258,14.272,1.881c4.819,1.004,9.428,2.281,13.736,3.896c18.24,6.889,30.193,20.027,35.857,36.166 c6.01,17.127,5.483,37.164,7.944,55.809c2.503,19.029,11.723,33.305,23.788,46.842c1.004,1.127,0.765,1.426-0.603,0.787 c-5.976-2.791-13.605-4.545-22.372-3.191c-1.49,0.229-1.457,0.445,0.049,0.523c14.826,0.742,22.39,11.977,29.584,19.77 c1.671,1.807,3.363,3.6,5.242,5.254c2.947,2.598,2.185,9.088,2.613,13.098c0.465,4.373,0.848,8.779,1.224,13.188 c1.043,38.594-3.51,64.049-5.196,72.002c-0.312,1.475,0.569,2.322,2.038,1.977c5.68-1.342,8.008-0.811,14.795,0.689 c7.751,1.713,64.588,2.809,62.005,0s-14.826-84.279-13.874-86.83c3.681-9.844,4.758-20.318,4.22-31.02 c-0.076-1.506,0.545-3.719,1.487-4.893c4.538-5.646,10.468-10.672,19.93-12.504c1.48-0.287,1.472-0.486-0.037-0.475 c-7.999,0.064-14.733,2.047-20.165,4.789c-1.347,0.68-2.484,0.713-2.595-0.018c-0.11-0.732,0.446-2.354,1.232-3.639 c8.422-13.783,13.838-28.051,12.653-45.15c-0.594-8.605-1.925-17.393-2.922-26.111c-0.172-1.5,0.646-3.492,1.802-4.459 c2.424-2.027,4.808-4.068,7.17-6.123c1.139-0.988,1.037-1.123-0.303-0.428c-1.711,0.887-3.541,1.643-5.438,2.328 c-1.417,0.516-1.536,0.246-0.175-0.4c0.686-0.324,1.398-0.631,2.143-0.914c1.41-0.537,1.373-0.754-0.117-0.516 c-1.144,0.184-2.255,0.418-3.332,0.686c-1.463,0.367-2.714-0.465-2.797-1.973c-0.346-6.312-0.251-12.527,0.72-18.541 c2.723-16.885,12.928-31.867,31.304-41.729c4.342-2.316,9.082-4.35,14.112-6.15c3.097-1.115,3.779-2.568,8.069-0.188 c2.833,1.57,5.591,3.17,8.996,3.801c10.386,1.967,19.633-0.371,25.836-3.834C451.657,289.785,451.446,289.201,449.941,289.311z M262.516,387.332c1.361-3.727,4.394-7.52,6.462-11.252c0.441-0.799,0.869-1.598,1.292-2.393c0.704-1.328,1.857-1.334,2.628-0.041 c3.819,6.385,8.461,12.32,13.626,18.119c1.003,1.127,0.762,1.426-0.603,0.789c-5.725-2.664-12.978-4.357-21.285-3.301 c-1.497,0.189-2.625-0.105-2.47-0.756C262.259,388.111,262.372,387.727,262.516,387.332z M301.681,450.398 c-8.21-10.631-21.652-17.617-29.575-28.516c-4.804-6.596-7.375-14.49-9.051-22.74c-0.429-2.09-1.062-4.244-1.215-6.539 c-0.101-1.506,1.3-2.744,2.803-2.615c14.131,1.205,21.527,12.059,28.55,19.666c1.671,1.805,3.363,3.598,5.242,5.254 c2.943,2.598,2.185,9.088,2.613,13.098c0.771,7.252,1.334,14.586,1.985,21.885C303.162,451.396,302.602,451.592,301.681,450.398z M347.104,365.807c0.101-0.24,0.208-0.18,0.202,0.133c-0.003,0.312-0.119,0.502-0.218,0.434 C346.993,366.303,347.003,366.049,347.104,365.807z M349.242,392.715c-0.055,6.719-0.792,13.305-3.023,19.408 c-0.517,1.418-1.291,1.338-1.615-0.135c-0.392-1.777-0.771-3.555-1.139-5.332c-0.808-3.947-3.507-9.9-1.493-13.271 c1.288-2.148,2.354-4.371,3.394-6.602c0.404-0.869,0.805-1.766,1.209-2.68c0.605-1.381,1.738-1.445,2.173,0 C349.644,387.078,349.27,389.982,349.242,392.715z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.993,
    cy: 148.098,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.093,
    cy: 157.278,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.213,
    cy: 168.832,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.573,
    cy: 211.672,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.295,
    cy: 143.235,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.092,
    cy: 139.331,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.617,
    cy: 101.953,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.765,
    cy: 229.637,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.901,
    cy: 267.774,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.545,
    cy: 122.528,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.424,
    cy: 158.474,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.287,
    cy: 204.316,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.566,
    cy: 109.991,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.212,
    cy: 88.927,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.614,
    cy: 207.052,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.254,
    cy: 249.892,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.492,
    cy: 171.892,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.839,
    cy: 223.995,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.689,
    cy: 310.776,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.968,
    cy: 275.96,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.127,
    cy: 324.143,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.174,
    cy: 135.552,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.458,
    cy: 184.132,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.566,
    cy: 330.636,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.222,
    cy: 39.725,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.736,
    cy: 321.083,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.175,
    cy: 290.697,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.899,
    cy: 258.677,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.389,
    cy: 66.836,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.327,
    cy: 42.356,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.891,
    cy: 19.862,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.6,
    cy: 182.042,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.622,
    cy: 278.154,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.948,
    cy: 258.677,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.486,
    cy: 272.814,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.21,
    cy: 342.876,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.488,
    cy: 338.944,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.485,
    cy: 219.292,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.468,
    cy: 163.092,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.623,
    cy: 174.42,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.528,
    cy: 115.796,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.327,
    cy: 90.129,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.377,
    cy: 58.382,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.369,
    cy: 103.721,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.31,
    cy: 149.622,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.513,
    cy: 78.244,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.599,
    cy: 90.129,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.747,
    cy: 53.464,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.052,
    cy: 207.376,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.327,
    cy: 384.538,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.031,
    cy: 62.216,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.211,
    cy: 108.116,
    r: 19.862
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.348,
    cy: 77.516,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.426,
    cy: 33.605,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.127,
    cy: 243.291,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.067,
    cy: 197.391,
    r: 19.863
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeofgold);
export default __webpack_public_path__ + "static/media/treeofgold.21d67aa8e77a5dfb6e099f71bcecf9bd.svg";
export { ForwardRef as ReactComponent };